import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchProfile, getLauncherUrl } from '../api/launcherApi';
import LanguageSwitcher from './LanguageSwitcher';

const styles = {
  navbar: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '60px',
    background: 'rgba(0, 0, 0, 0.8)',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px',
    zIndex: 1000,
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  logoIcon: {
    fontSize: '28px',
  },
  logoText: {
    fontSize: '20px',
    fontWeight: 'bold',
    background: 'linear-gradient(90deg, #00d4ff, #7c3aed)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  searchInput: {
    padding: '8px 16px',
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    background: 'rgba(255, 255, 255, 0.1)',
    color: '#fff',
    outline: 'none',
    width: '250px',
    fontSize: '14px',
  },
  countryCount: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  userSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 12px',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
  userAvatar: {
    fontSize: '18px',
  },
  userName: {
    fontSize: '14px',
    color: '#fff',
    fontWeight: '500',
  },
  trophyButton: {
    background: 'rgba(255, 215, 0, 0.2)',
    border: '1px solid rgba(255, 215, 0, 0.4)',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  homeButton: {
    background: 'rgba(100, 150, 255, 0.2)',
    border: '1px solid rgba(100, 150, 255, 0.4)',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
};

const Navbar = ({ searchTerm, onSearchChange, countryCount }) => {
  const { t } = useTranslation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loadProfile = async () => {
      const profile = await fetchProfile();
      if (profile) {
        setUser(profile);
      }
    };
    loadProfile();
  }, []);

  const goToLauncher = () => {
    // Cookie-based auth - no token needed in URL
    window.location.href = `${getLauncherUrl()}/command-center`;
  };

  const goToAchievements = () => {
    // Cookie-based auth - no token needed in URL
    window.location.href = `${getLauncherUrl()}/achievements`;
  };

  return (
    <nav style={styles.navbar}>
      <div style={styles.logo}>
        <span style={styles.logoIcon}>🌍</span>
        <span style={styles.logoText}>{t('home.title')}</span>
      </div>
      <div style={styles.searchContainer}>
        <input
          type="text"
          placeholder={t('home.searchPlaceholder')}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          style={styles.searchInput}
        />
        <span style={styles.countryCount}>{countryCount} {t('home.countriesCount')}</span>
      </div>
      <div style={styles.userSection}>
        <LanguageSwitcher />
        <button
          style={styles.homeButton}
          onClick={goToLauncher}
          title={t('common.commandCenter')}
        >
          🚀
        </button>
        <button
          style={styles.trophyButton}
          onClick={goToAchievements}
          title={t('common.achievements')}
        >
          🏆
        </button>
        <div style={styles.userInfo}>
          <span style={styles.userAvatar}>{user ? '👤' : '👻'}</span>
          <span style={styles.userName}>{user?.name || t('common.guest')}</span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
